import CustomerRepository from "../repositories/CustomerRepository";

export class CustomerService {
  static GetCustomersByNameOrId(instance, search) {
    const repo = new CustomerRepository;

    return repo.getCustomersByNameOrId(instance, search);
  }
}